import Carousel from "@/components/Carousel";

export default function Awards() {
    const content = window.ein?.content?.step_5 || {}
    const {awards} = content
    return (
        <>
            <div className="heading-h2 mb-[16px] text-center">
                {awards?.heading}
            </div>
            <div className="text-big text-brand-grey mb-[16px] text-center">
                {awards?.subheading}
            </div>
            {awards?.logos && awards?.logos.length > 0 && (
                <Carousel
                    autoplay={{delay: 3000}}
                    loop={true}
                    slides={awards.logos}
                    spaceBetween={42}
                    renderSlide={(logo, i) => (
                        <div className={`shadow-sm bg-ice-grey h-full flex items-center justify-center ${logo.extra_padding ? 'p-[24px]' : ''}`}>
                            <img src={logo.logo.url} alt={logo.logo.alt || `Logo ${i+1}`}/>
                        </div>
                    )}
                />
            )}
        </>
    )
}
